import instance from '.';

export const setApiAuthorization = (token: string) => {
	instance.defaults.headers.common['authorization'] = 'Bearer ' + token;
};

export const resetToken = () => {
	instance.defaults.headers.common['authorization'] = null;
};

export const isUnauthorizedError = (error: any) => {
	const {
		response: { status },
	} = error;
	return status === 401;
};
